module.exports = __webpack_public_path__ + "static/media/vf_msneakers_core.0206d8e0.svg";